exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body-main[data-v-2a5617ac]{position:relative}.modal-body-main .row-col-info[data-v-2a5617ac]{display:inline-block;padding:0;margin:0;width:100%;text-align:left}.modal-body-main .grid-vertical-center[data-v-2a5617ac]{display:grid;-webkit-box-align:center;-ms-flex-align:center;align-items:center;grid-template-columns:auto 100px}.modal-body-main .product-sku-number[data-v-2a5617ac]{padding:0 10px;font-size:16px;text-align:right}", ""]);

// exports
